import React from "react";
import MediaDirectoryTree from "../component/MediaDirectoryTree";

const MediaDirectoryTreeContainer = ({ pageId }) => (<MediaDirectoryTree pageId={ pageId} />)

export default MediaDirectoryTreeContainer;